import { render, staticRenderFns } from "./ClassAboutView.vue?vue&type=template&id=65a667be&scoped=true&"
import script from "./ClassAboutView.vue?vue&type=script&lang=js&"
export * from "./ClassAboutView.vue?vue&type=script&lang=js&"
import style0 from "./ClassAboutView.vue?vue&type=style&index=0&id=65a667be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a667be",
  null
  
)

export default component.exports